import { StandardProps } from "../componentMap";
import { logger } from "../../utils";
import { useEffect } from "react";

export type TaggstarConfigProps = {
  experience: string;
};

export const Taggstar = ({
  configProps,
  experiences,
}: Pick<StandardProps, "configProps" | "experiences">) => {
  const { experience } = configProps as TaggstarConfigProps;

  const taggstarDisabled =
    experiences && experiences["taggstar-feature"] === "off";

  const taggstarControl =
    experiences && experiences["taggstar-feature"] === "control";

  useEffect(() => {
    if (taggstarDisabled) return;

    if (taggstarControl) {
      document.body.dataset.taggExperience = "control";
    } else {
      if (experience) {
        document.body.dataset.taggExperience = experience;
      } else {
        logger(
          "Error in Taggstar component: experience not provided in configuration.",
        );
      }
    }
  }, []);

  return null;
};
